export const CONTACT_US_URL = 'https://www.justsalad.com/contact-us/';

// No trailing punctuation after the URL — autolinkifiers swallow it into the
// href and the user lands on a 404.
export const GENERIC_ERROR_MESSAGE = `Something went wrong. Please try again or contact us at ${CONTACT_US_URL}`;

const AppStrings = {
    whatIsKgCo: 'What is kg CO',
    co2eMeaning:
        "e? That's a carbon label! It shows the estimated greenhouse gas emissions of your meal. Verified by Planet FWD.",
    learnMoreAboutCarbonLabels: 'Learn More About Carbon Labels.',
    learnMoreAt: 'Learn more at:'
};

export default AppStrings;
